// extracted by mini-css-extract-plugin
module.exports = {"restrictionModal":"RestictionModal_restrictionModal__k5e89","modalClose":"RestictionModal_modalClose__3-5q6"};